import { StyleSheet } from 'react-native'
import { Metrics } from 'APP/Themes'

export default StyleSheet.create({
  noCarePlans: {
    paddingTop: Metrics.baseMargin * 2,
  },
})
